import type { UiKitDictionary } from './uiKitDictionaryTypes';

export const RU_UI_KIT: UiKitDictionary = {
    shellEyebrow: 'Админ / UI kit',
    title: 'Web UI kit',
    description: 'Общие примитивы интерфейса, которые используются в логине, дашборде, звонках и админских поверхностях Chattenger.',
    buttonsAndBadges: 'Кнопки и badges',
    inputsAndSelects: 'Поля и selects',
    structuredInput: 'Структурированный ввод',
    overlayTitle: 'Sheet',
    overlayCopy: 'Mobile-first overlays используют тот же shell-подход, что и explorer вложений в шапке чата.',
    openShowcaseSheet: 'Открыть showcase sheet',
    showcaseSheetEyebrow: 'UI kit',
    showcaseSheetTitle: 'Showcase sheet',
    showcaseSheetCopy: 'Sheet-примитив — это общая база для mobile-first overlay поверхностей в новом веб-клиенте.',
    actionsCardLabel: 'Действия',
    demoButtonPrimary: 'Primary',
    demoButtonSecondary: 'Secondary',
    demoButtonGhost: 'Ghost',
    demoButtonCompact: 'Компактная',
    badgeDefaultDemo: 'Default',
    badgeAccentDemo: 'Accent',
    badgeMutedDemo: 'Muted',
    badgeDangerDemo: 'Danger',
    selectionCardLabel: 'Выбор',
    roleSelectLabel: 'Роль',
    resourcesSelectLabel: 'Ресурсы',
    resourcesHint: 'Типичный выбор ресурсов CRM.',
    resourceOptionMessages: 'Сообщения',
    resourceOptionStats: 'Статистика',
    resourceOptionPermissions: 'Права',
    resourceOptionUsers: 'Пользователи',
    structuredCardLabel: 'Структурированный ввод',
    arrayInputLabel: 'Email для уведомлений',
    arrayInputAddLabel: 'Добавить email',
    overlaysCardLabel: 'Оверлеи',
    tabsShowcaseLabel: 'Витрина UI kit',
    catalogNavigationLabel: 'Разделы каталога UI kit',
    catalogControlsTab: 'Элементы управления',
    catalogFeedbackTab: 'Состояния и оверлеи',
    catalogDataTab: 'Данные и медиа',
    catalogTextFieldLabel: 'Адрес для уведомлений',
    catalogTextFieldHint: 'Обычное, отключённое и ошибочное состояния показаны вместе.',
    catalogTextFieldError: 'Введите полный адрес.',
    catalogOtpLabel: 'Одноразовый код',
    catalogSliderLabel: 'Значение предпросмотра',
    catalogArrayPlaceholder: 'Введите адрес для уведомлений',
    catalogRemoveValueLabel: 'Удалить значение',
    catalogEmptySelection: 'Ничего не выбрано',
    catalogSelectAction: 'Выбрать',
    catalogSelectedAction: 'Выбрано',
    catalogLoadingLabel: 'Загрузка предпросмотра компонента',
    catalogSettingsLabel: 'Настройки каталога',
    catalogToastAction: 'Показать уведомление',
    catalogToastMessage: 'Действие предпросмотра UI kit выполнено.',
    catalogTableLabel: 'Таблица состояний компонентов',
    catalogTableColumnComponent: 'Компонент',
    catalogTableColumnState: 'Состояние',
    catalogTableValueReady: 'Готово',
    catalogEmptyStateTitle: 'Нет демонстрационных записей',
    catalogEmptyStateCopy: 'Для этого состояния каталога нет демонстрационных записей.',
    catalogShowEmptyState: 'Показать пустое состояние',
    catalogShowPopulatedState: 'Показать заполненное состояние',
    catalogQrTitle: 'QR-код фикстуры каталога',
    catalogMediaAction: 'Открыть предпросмотр медиа',
    catalogMediaLabel: 'Предпросмотр вложения каталога',
    catalogMediaMeta: 'Безопасная локальная фикстура каталога',
    roleDemoUser: 'Обычный пользователь',
    roleDemoAdmin: 'Админ',
    roleDemoSuperAdmin: 'Супер-админ',
};
